module.exports = __webpack_public_path__ + "img/9788999708145.45057c8b.jpg";